import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
} from '@/components/ui/sidebar';
import { BTrackMenuItem } from './BTrackMenuItem';

export function NavModules() {
  return (
    <SidebarGroup className="group-data-[collapsible=icon]:hidden">
      <SidebarGroupLabel>Módulos</SidebarGroupLabel>
      <SidebarMenu>
        <BTrackMenuItem />
      </SidebarMenu>
    </SidebarGroup>
  );
}
